export default [
  {
    "kod": "CZ010",
    "nazev": "Hlavní město Praha",
    "val": "CZ010 Hlavni mesto Praha Hlavní město Praha"
  },
  {
    "kod": "CZ020",
    "nazev": "Středočeský kraj",
    "val": "CZ020 Stredocesky kraj Středočeský kraj"
  },
  {
    "kod": "CZ031",
    "nazev": "Jihočeský kraj",
    "val": "CZ031 Jihocesky kraj Jihočeský kraj"
  },
  {
    "kod": "CZ032",
    "nazev": "Plzeňský kraj",
    "val": "CZ032 Plzensky kraj Plzeňský kraj"
  },
  {
    "kod": "CZ041",
    "nazev": "Karlovarský kraj",
    "val": "CZ041 Karlovarsky kraj Karlovarský kraj"
  },
  {
    "kod": "CZ042",
    "nazev": "Ústecký kraj",
    "val": "CZ042 Ustecky kraj Ústecký kraj"
  },
  {
    "kod": "CZ051",
    "nazev": "Liberecký kraj",
    "val": "CZ051 Liberecky kraj Liberecký kraj"
  },
  {
    "kod": "CZ052",
    "nazev": "Královéhradecký kraj",
    "val": "CZ052 Kralovehradecky kraj Královéhradecký kraj"
  },
  {
    "kod": "CZ053",
    "nazev": "Pardubický kraj",
    "val": "CZ053 Pardubicky kraj Pardubický kraj"
  },
  {
    "kod": "CZ063",
    "nazev": "Kraj Vysočina",
    "val": "CZ063 Kraj Vysocina Kraj Vysočina"
  },
  {
    "kod": "CZ064",
    "nazev": "Jihomoravský kraj",
    "val": "CZ064 Jihomoravsky kraj Jihomoravský kraj"
  },
  {
    "kod": "CZ071",
    "nazev": "Olomoucký kraj",
    "val": "CZ071 Olomoucky kraj Olomoucký kraj"
  },
  {
    "kod": "CZ072",
    "nazev": "Zlínský kraj",
    "val": "CZ072 Zlinsky kraj Zlínský kraj"
  },
  {
    "kod": "CZ080",
    "nazev": "Moravskoslezský kraj",
    "val": "CZ080 Moravskoslezsky kraj Moravskoslezský kraj"
  }
]



// WEBPACK FOOTER //
// build/services/regionDimensions/regionData.js